import { SVAutocomplete, SVButton } from '@/components/core';
import { FORM_FIELDS } from '@/constants/formFields';
import { Card, Typography, Grid, Box } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

type BrandingThemeSectionProps = {
  brandingThemeOptions: Array<{
    label: string;
    value: string | number;
    icon?: React.ElementType | null;
    iconColor?: any;
    iconUrl?: string;
    additionalInfo?: string;
  }>;
  isBrandingThemesPending: boolean;
  selectedBrandingTheme: string;
  onViewBrandingTheme: () => void;
};

export default function BrandingThemeSection({
  brandingThemeOptions,
  isBrandingThemesPending,
  selectedBrandingTheme,
  onViewBrandingTheme,
}: BrandingThemeSectionProps) {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Branding Theme
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select a branding theme for the company.
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, md: 6 }}>
          <SVAutocomplete
            name="brandingThemeId"
            {...FORM_FIELDS.BRANDING_THEME}
            options={brandingThemeOptions}
            disabled={isBrandingThemesPending}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <SVButton
              variant="primary"
              onClick={onViewBrandingTheme}
              startIcon={<VisibilityIcon />}
              disabled={!selectedBrandingTheme}>
              View Branding Theme
            </SVButton>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
}
